import React from 'react';
import { AddTestMeasurementConnectorApollo } from '@front-activerse/common-components';
import LabTestsAddContainer from './LabTestsAddContainer';

const TestsAddPage: React.FC = () => {
  return (
    <AddTestMeasurementConnectorApollo>
      {({ addTestMeasurement }: { addTestMeasurement: (data: any) => void }) => (
        <LabTestsAddContainer addTestMeasurement={addTestMeasurement} />
      )}
    </AddTestMeasurementConnectorApollo>
  );
};

export default TestsAddPage;
